class Streusel { }

Streusel.selectorType = 'css_class';
Streusel.selectorPrefix = 'js';

export default Streusel;



// WEBPACK FOOTER //
// ./src/_config/streusel.js